import React from "react";
import Link from "next/link";

type ButtonLinkProps = {
  href: string;
  id?: string;
  className?: string;
  prefetch?: boolean;
  children: React.ReactNode;
};

export function ButtonLink({
  href,
  id,
  className = "",
  prefetch,
  children,
}: ButtonLinkProps) {
  return (
    <Link
      className={`text-brandcolor ${className}`}
      href={href}
      id={id}
      prefetch={prefetch}
    >
      {children}
    </Link>
  );
}
